export const TRANSLATIONS = {
  ACCOUNT: 'account',
  BLOG: 'blog',
  CHECKOUT: 'checkout',
  CAMPAIGNS: 'campaigns',
  COMMON: 'common',
  HOME: 'home',
  RECIPES: 'recipes'
} as const;
